const colors = {
  Alabaster: '#FAFAFA',
  Black: '#000000',
  Carnation: '#F34F66',
  CornflowerBlue: '#735bf7',
  DeepCerulean: '#008aa4',
  Jade: '#00c248',
  FlushOrange: '#FF8300',
  Froly: '#F77E69',
  Gallery: '#EBEBEB',
  Harlequin: '#35C100',
  HavelockBlue: '#428EE0',
  LimedSpruce: '#3C4754',
  Mako: '#42474B',
  Mercury: '#E2E2E2',
  Mystic: '#E5E8F1',
  OuterSpace: '#2C3237',
  PaleSky: '#6E7686',
  RipeLemon: '#F7D320',
  Shark: '#1C2125',
  SilverChalice: '#AAAAAA',
  White: '#FFFFFF',
};

export default colors;
